'use client'

import { Spacer, Text } from '@vinted/web-ui'
import { useIntl } from 'react-intl'

import { CurrencyAmountModel, formatCurrencyAmount } from '@marketplace-web/currency/currency-data'

type Props = {
  price: CurrencyAmountModel
  offerPrice: CurrencyAmountModel | null
  isItemOwner: boolean
}

// TODO: if similar functionality is used elsewhere, move up the component into a separate file.
const Price = ({
  price,
  isItemOwner,
  ...props
}: Pick<Props, 'price' | 'isItemOwner'> & Omit<React.ComponentProps<typeof Text>, 'text'>) => {
  const { locale } = useIntl()

  return (
    <Text type={Text.Type.Subtitle} {...props} text={formatCurrencyAmount(price, locale)} as="p" />
  )
}

const ItemPriceHeading = ({ price, offerPrice, isItemOwner }: Props) => {
  const hasSpecialOffer = Boolean(offerPrice && offerPrice.amount !== price.amount)

  const renderPriceWithStrikethrough = (
    mainPrice: CurrencyAmountModel,
    strikethroughPrice: CurrencyAmountModel,
  ) => (
    <div className="u-flexbox u-align-items-center">
      <Price as="p" price={mainPrice} isItemOwner={isItemOwner} />
      <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Small} />
      <Price
        as="p"
        price={strikethroughPrice}
        type={Text.Type.Subtitle}
        strikethrough
        isItemOwner={isItemOwner}
      />
    </div>
  )

  const renderPriceField = () => {
    if (hasSpecialOffer && offerPrice) {
      return renderPriceWithStrikethrough(offerPrice, price)
    }

    return <Price as="p" price={price} isItemOwner={isItemOwner} />
  }

  return (
    <div className="u-flexbox u-align-items-center" data-testid="item-price">
      {renderPriceField()}
    </div>
  )
}

export default ItemPriceHeading
